<script lang="ts">
	import loginButtonMobileSvg from './svg/login-button-mobile.svg';
	import loginButtonSvg from './svg/login-button.svg';
	import logoutButtonMobileSvg from './svg/logout-button-mobile.svg';
	import logoutButtonSvg from './svg/logout-button.svg';
	import { _ } from 'svelte-i18n';
	import { isMobile } from '$lib/stores';
	import { page } from '$app/stores';
	import LoginLink from '$lib/components/LoginLink.svelte';
</script>

<LoginLink>
	<div>
		{#if $page.data.session?.user}
			{#if $isMobile}
				<img
					src={logoutButtonMobileSvg}
					alt={$_('components.navbar.logout')}
					width="150"
					height="150"
				/>
			{:else}
				<span class="login">
					<svg
						version="1.1"
						id="Ebene_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						style="enable-background:new 0 0 40 40;"
						width="20"
						height="20"
					>
						<style type="text/css">
							.st0 {
								fill: #000;
							}
						</style>
						<g id="icon_00000072977847050887814730000002293959470805914768_">
							<path
								class="st0"
								d="M29,34.8V28c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6v6.8c0,1.1-0.9,2-2,2H7.2c-1.1,0-2-0.9-2-2V5.2
c0-1.1,0.9-2,2-2h16.6c1.1,0,2,0.9,2,2V12c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V5.2C29,2.3,26.7,0,23.8,0H7.2
C4.3,0,2,2.3,2,5.2v29.6C2,37.7,4.3,40,7.2,40h16.6C26.7,40,29,37.7,29,34.8z"
							/>
							<path
								class="st0"
								d="M33.5,27.2l6-6c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1
c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1
c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1
c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0v0l0,0
l-6-6c-0.6-0.6-1.6-0.6-2.2,0c-0.6,0.6-0.6,1.6,0,2.2l3.4,3.4H16.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6h18.3l-3.4,3.4
c-0.6,0.6-0.6,1.6,0,2.2C31.9,27.8,32.9,27.8,33.5,27.2z"
							/>
						</g>
					</svg>

					{$_('components.navbar.logout')}</span
				>
			{/if}
		{:else if $isMobile}
			<img
				src={loginButtonMobileSvg}
				alt={$_('components.navbar.login')}
				width="150"
				height="150"
			/>
		{:else}
			<span class="login">
				<svg
					version="1.1"
					id="Ebene_1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					style="enable-background:new 0 0 40 40;"
					width="20"
					height="20"
				>
					<style type="text/css">
						.st0 {
							fill: #000;
						}
						.st1 {
							fill: none;
							stroke: #000;
							stroke-miterlimit: 10;
						}
					</style>
					<g>
						<path
							class="st0"
							d="M27.1,24.3c-4.2,6.1-9.9,5.5-13.4,0c-3.8,1.3-5.5,3.6-5.7,7.6c0,0.8,0.2,1.9,0,2.7C8,35,7.4,35.4,7,35.9
		c-0.4-0.4-1.1-0.6-1.1-1.3c-1.1-6.1,1.9-11.1,7.8-13c0.4-0.2,1.3,0.2,1.7,0.6c0.6,0.6,0.8,1.5,1.5,2.1c2.1,2.3,5,2.5,7.1,0.2
		c0.2-0.2,0.4-0.6,0.6-0.8c1.9-2.7,1.9-2.5,4.8-1.1c3.8,1.9,5.7,5,5.7,9.2c0,2.1,0.2,4,0.2,6.1c0,1.3-0.6,1.9-1.9,1.9
		c-8.6,0-17.2,0-26,0c-0.8,0-1.7-0.2-1.7-1.3c0-1.1,0.8-1.3,1.7-1.3c7.8,0,15.8,0,23.5,0c1.9,0,1.9,0,1.9-1.9c0-1.5-0.2-3.2-0.2-4.6
		C32.4,27.2,30.1,25.6,27.1,24.3z"
						/>
						<path
							class="st0"
							d="M29.5,10.4c-0.2,4.2-1.9,7.6-4.8,10.3c-1.3,1.1-2.5,2.1-3.8,2.9c-0.6,0.4-1.5,0.8-1.9-0.2
		c-0.2-0.4,0.2-1.5,0.6-1.9c1.7-1.7,3.8-2.9,5.3-4.8c2.1-2.5,2.9-5.5,2.1-8.6c-0.8-4-4.2-6.1-8.4-5.3c-3.6,0.8-5.9,4.4-5.3,8.4
		c0.4,2.9,1.9,5.3,4.4,6.7c0.6,0.4,1.5,0.8,0.8,1.9c-0.6,1.1-1.5,0.6-2.1,0.2c-5.5-2.9-7.4-10.7-3.8-16c2.1-3.2,5.9-4.4,10.1-3.6
		c3.4,0.8,6.1,4,6.5,7.8C29.5,9.4,29.5,9.8,29.5,10.4z"
						/>
						<circle class="st1" cx="26.9" cy="30.4" r="2.1" />
					</g>
				</svg>
				{$_('components.navbar.login')}</span
			>
		{/if}
	</div>
</LoginLink>

<style>
	div {
		padding: 0;
		margin: 0 1rem;
	}

	img {
		height: 40px;
		width: auto;
	}

	.login {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 10px 20px 10px 10px;
		color: #1d4a97;
		text-transform: uppercase;
		font-size: 13px;
		font-family: 'Schalke04Text-Bold', sans-serif;
		white-space: nowrap;
		background: #f4f4f4;
		border-radius: 4px;
	}

	.login svg {
		margin-right: 10px;
	}
</style>
